import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";
import React from "react";

export const SourceSortDescIcon = ({
  width = "21",
  height = "21",
  style,
  onClick,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill="#1F293299"
          d="M8 16h12V6H8zm0 2q-.825 0-1.412-.587T6 16V4q0-.825.588-1.412T8 2h12q.825 0 1.413.588T22 4v12q0 .825-.587 1.413T20 18zm-4 4q-.825 0-1.412-.587T2 20V6h2v14h14v2zM8 4v12z"
        ></path>
      </svg>
    </IconWrapper>
  );
};
